import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { addMobileDetectionListener } from '../utils/deviceDetection';

function Footer() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 모바일 감지 리스너 추가
    const cleanupMobileListener = addMobileDetectionListener(setIsMobile);

    return () => {
      cleanupMobileListener();
    };
  }, []);

  return (
    <footer className={`footer ${isMobile ? 'mobile-device' : ''}`}>
      <div className="footer-content">
        {/* 데스크톱에서만 네비게이션 표시 */}
        {!isMobile && (
          <>
            <div className="footer-navigation">
              <div className="footer-column">
                <h4>오픈소스</h4>
                <ul>
                  <li><Link to="/opensource?category=linux-os">Linux OS</Link></li>
                  <li><Link to="/opensource?category=web-was">WEB/WAS</Link></li>
                  <li><Link to="/opensource?category=dbms">DBMS</Link></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>인프라솔루션</h4>
                <ul>
                  <li><Link to="/solutions?category=lena">LENA</Link></li>
                  <li><Link to="/solutions?category=redhat">RedHat</Link></li>
                  <li><Link to="/solutions?category=resin">Resin</Link></li>
                  <li><Link to="/solutions?category=agenssql">AgensSQL</Link></li>
                  <li><Link to="/solutions?category=oracletibero">Oracle/Tibero</Link></li>
                  <li><Link to="/solutions?category=clusterplex">ClusterPlex</Link></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>보안솔루션</h4>
                <ul>
                <li><Link to="/security?category=uclm">UCLM</Link></li>
                  <li><Link to="/security?category=dguard">D'Guard</Link></li>
                  <li><Link to="/security?category=dguard-eye">D'Guard EYE</Link></li>
                  <li><Link to="/security?category=loguard">LOGuard</Link></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>모니터링</h4>
                <ul>
                  <li><Link to="/monitoring?category=jennifer">Jennifer</Link></li>
                  <li><Link to="/monitoring?category=maxgauge">MaxGauge</Link></li>
                  <li><Link to="/monitoring?category=tamis">TAMIS</Link></li>
                  <li><Link to="/monitoring?category=eg-enterprise">eG Enterprise</Link></li>
                  <li><Link to="/monitoring?category=owlens">OWLens</Link></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>기술서비스</h4>
                <ul>
                  <li><Link to="/support?category=carepack">케어팩서비스</Link></li>
                  <li><Link to="/support?category=dbms-consulting">DBMS컨설팅</Link></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>기타</h4>
                <ul>
                  <li><a href="https://blog.naver.com/xestinf" target="_blank" rel="noopener noreferrer">기술블로그</a></li>
                  <li><Link to="/about">회사소개</Link></li>
                </ul>
              </div>
            </div>
            <hr className="footer-divider" />
          </>
        )}
        
        {/* 회사정보는 항상 표시 */}
        <div className="footer-bottom">
          <div className="footer-top">
            <div className="footer-logo">
              <div className="logo-icon">X</div>
              <div className="logo-text">
                <div className="logo-main">XEST</div>
                <div className="logo-sub">Information Technology</div>
              </div>
            </div>
          </div>
          <div className="footer-middle">
            <div className="company-info-line">
              (주)제스트정보기술 | 대표자명: 임항순   
              
            </div>
            <div className="company-info-line">
              우: 08505 서울시 금천구 디지털로 121, 7층 703호 (에이스가산타워)
            </div>
          </div>
          <div className="footer-contact-bottom">
            <div className="contact-line">
              <span className="contact-label">서비스 상담:</span>
              <span className="contact-phone">02-558-5918</span>
              <span className="contact-email">sales@xest.kr</span>
              <span className="contact-separator">|</span>
              <span className="contact-label">FAX:</span>
              <span className="contact-phone">02-558-5913</span>
            </div>
          </div>
          <div className="footer-copyright">
            © Copyright Xest Information Technology, Inc. All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 